exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".emlqfrVb8fPIzuHvzq75Z{position:absolute;top:0;bottom:0;z-index:-1}html[dir] .emlqfrVb8fPIzuHvzq75Z{background-color:\"[theme:neutralLighterAlt, default:#f8f8f8]\"}html[dir=ltr] .emlqfrVb8fPIzuHvzq75Z,html[dir=rtl] .emlqfrVb8fPIzuHvzq75Z{left:0;right:0}", ""]);
// Exports
exports.locals = {
	"pastHighlight": "emlqfrVb8fPIzuHvzq75Z"
};